<template lang="pug">
    include DashboardCertificates.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api";

export default {
  name: 'DashboardCertificates',
  data() {
    return {
      link: null,
    }
  },
  async created() {
    const _this = this;
    this.token = this.$store.state.token;

    const meResponse = await Api.me(this.token)
    const response = meResponse.data
    this.link = response.certificate
  },
}
</script>

<style scoped lang="scss">
@import "./../../styles/common_forms";
@import "./../benefits/BenefitsPack";

.certificates-boxes .container-bienvenido .boxes-wrapper {
  border: none;
}
.certificates-boxes .container-bienvenido .fila {
  grid-template-columns: 1fr 1fr;

  @include breakpoint($breakpoint-xmobile) {
      grid-template-columns: 1fr;
  }
}

@import "Dashboard";

</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCertificates.vue